import { guestConstants } from "../_constants/guest.constants";
import { ServiceUtil } from "../_services/services.util";

export const guestActions = {
    loadGuestDashboard,
};

function loadGuestDashboard(userHash) {
    return async dispatch => {
        dispatch(request(userHash));
        try {
            const response = await ServiceUtil.getGuestDashboard(userHash);
            if (response && response.data) {
                dispatch(success(response.data));
            } else {
                dispatch(failure(response));
            }
            return response;
        } catch (error) {
            dispatch(failure(error));
            return error;
        }
    };

    function request(userHash) {
        return { type: guestConstants.GUEST_DASHBOARD_LOADING, userHash };
    }
    function success(dashboard) {
        return { type: guestConstants.GUEST_DASHBOARD_SUCCESS, dashboard };
    }
    function failure(error) {
        return { type: guestConstants.GUEST_DASHBOARD_FAILED, error };
    }
}
